import {EPaymentType, ETransactionTrafficType, ETransactionType} from './definitions';

export default {
  total: 'Total: ',
  loading: 'Uploading data',
  allTransactions: 'Debited from the account <0></0>, credited to the account <1></1>',
  credit: 'Credited to the account {{value}}',
  debit: 'Debited from the account {{value}}',
  button: {
    downloadList: 'Download list',
  },
  listFileName: 'Statement.xlsx',
  th: {
    date: 'Date',
    dailyStatement: 'Balancing statement for the day',
    createdAt: 'Transaction date',
    amount: 'Amount',
    description: 'Transaction description',
  },
  filters: {
    title: 'Filters',
    reset: 'Reset',
    debit: 'Debit',
    credit: 'Credit',
    allOperations: 'All transactions',
  },
  trafficType: {
    [ETransactionTrafficType.SERVICE]: 'Service messages',
    [ETransactionTrafficType.AD]: 'Advertising messages',
    [ETransactionTrafficType.MARKETING]: 'Marketing messages',
    [ETransactionTrafficType.MULTINAMING]: 'Multinaming',
  },
  smsTrafficType: {
    [ETransactionTrafficType.SERVICE]: 'Service',
    [ETransactionTrafficType.AUTH]: 'Authentication',
    [ETransactionTrafficType.INFO]: 'Advertising',
    [ETransactionTrafficType.MRKT]: 'Advertising',
    [ETransactionTrafficType.TEMPLATE_ADV]: 'Advertising',
    [ETransactionTrafficType.ADVERTISEMENT]: 'Advertising',
    [ETransactionTrafficType.AD]: 'Advertising',
    [ETransactionTrafficType.MULTINAMING]: 'Multinaming',
  },
  item: {
    statement: `Statement`,
    changed: 'Changed',
    cancelled: 'Cancelled:',
    debit: 'Debited – {{value}}',
    credit: 'Credited – {{value}}',
    debitTh: {
      type: 'Type',
      count: 'Count',
      amount: 'Amount',
    },
    creditTh: {
      paymentPurpose: 'Payment purpose description',
      amount: 'Amount',
      invoice: 'Payment for licenses and services',
    },
    paymentType: {
      [EPaymentType.INIT]: 'Activation',
      [EPaymentType.RENEWAL]: 'Renewal',
    },
    number: ' (number {{channelAttribute}})',
    account: ', {{subject}} account',
    [ETransactionType.WHATSAPP_AMAU_PAYMENT]:
      'Message routing services via edna Pulse{{account}}{{number}}. AMAU',
    [ETransactionType.WHATSAPP_CONVERSATION_BILLED]:
      'Opening a conversation via edna Pulse{{account}}{{number}}. Conversations',
    [ETransactionType.WHATSAPP_OUT_MESSAGE_BILLED]:
      'Message routing services via edna Pulse{{account}}{{number}}',
    [ETransactionType.WHATSAPP_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with WhatsApp channel connection (MAU {{mauCount}}){{account}}{{number}}, {{month}} {{year}}.',
    [ETransactionType.WHATSAPP_CONNECTION_FEE]:
      'Connection of a phone number {{number}} MAU {{mauCount}}, {{month}} {{year}}.',
    [ETransactionType.SMS_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with the connection of the channel SMS, {{month}} {{year}}',
    [ETransactionType.MAX_BOT_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with the connection of the channel MAX Bot{{account}}, {{month}} {{year}}',
    [ETransactionType.MAX_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with the connection of the channel MAX{{account}}, {{month}} {{year}}',
    [ETransactionType.TG_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with the connection of the channel Telegram{{account}}, {{month}} {{year}}',
    [ETransactionType.VIBER_LICENSE_PAYMENT]:
      '{{paymentType}} of the license to use edna Pulse with the connection of the channel VIBER, {{month}} {{year}}',
    [ETransactionType.VIBER_OUT_MESSAGE_BILLED]:
      'Message routing services via edna Pulse{{account}}. {{trafficType}}',
    [ETransactionType.VIBER_RECURRENT_PAYMENT]:
      'Viber minimum fee over the period of {{month}} {{year}}{{account}}}.  ',
    [ETransactionType.SMS_OUT_MESSAGE_BILLED]:
      'Message routing services via edna Pulse, alphanumeric signature {{subject}}. {{trafficType}}',
    [ETransactionType.SMS_RECURRENT_BILLED]:
      'The subscription fee for using an alphanumeric signature ({{subject}}, operator «{{mobileOperator}}») for the {{month}} {{year}}.',
    [ETransactionType.SMS_TEMPLATE_BILLED]:
      'Operator SMS template fee ({{templateName}} for sender {{subject}}, operator «{{mobileOperator}}») for the {{month}} {{year}}.',
    [ETransactionType.VIBER_CORRECTION_BILLED]: 'Balance adjustment (foreign currency revaluation)',
    [ETransactionType.WHATSAPP_CORRECTION_BILLED]:
      'Balance adjustment (foreign currency revaluation)',
    [ETransactionType.PAYKEEPER_PAYMENT]:
      'Prepayment by card for licenses and services {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_FULL_REFUND]:
      'Refund of a card payment from {{date}} {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_PARTIAL_REFUND]:
      'Refund of a card payment from {{date}} {{inn}} {{tenantId}} {{email}}',
    [ETransactionType.PAYKEEPER_RECURRENT_PAYMENT]: 'Auto payment {{inn}} {{tenantId}} {{email}}',
  },
};
